import { Text } from 'ui'
import { usePendingInvitesContext } from '../context/PendingInvitesProvider'

export const EmptyState = () => {
  const {
    state: { hasNoSearchResults },
  } = usePendingInvitesContext()

  return (
    <Text color="lightText" mb={3}>
      {hasNoSearchResults
        ? 'No pending invites match your search.'
        : 'Pending invites will appear here.'}
    </Text>
  )
}
